var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2388(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2388",
    "data-name": "Group 2388",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.111,
    height: 17.02,
    viewBox: "0 0 13.111 17.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1664",
    "data-name": "Rectangle 1664",
    width: 13.111,
    height: 17.02,
    fill: "none",
    stroke: "#1d1d1d",
    strokeWidth: 0.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49188",
    "data-name": "Path 49188",
    d: "M5.6,15.475H1.159A.659.659,0,0,1,.5,14.817V2.88a.656.656,0,0,1,.193-.465L2.415.693A.66.66,0,0,1,2.88.5H10.7a.658.658,0,0,1,.658.659V7.95",
    transform: "translate(-0.169 -0.169)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 1.676,
    transform: "translate(5.972 6.796)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49189",
    "data-name": "Path 49189",
    d: "M.722,2.613H2.554a.28.28,0,0,0,.28-.279V.517",
    transform: "translate(-0.244 -0.175)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49190",
    "data-name": "Path 49190",
    d: "M3.232,6.205h7.236",
    transform: "translate(-1.092 -2.097)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 2.644,
    transform: "translate(2.14 6.796)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49191",
    "data-name": "Path 49191",
    d: "M3.232,8.235h7.236",
    transform: "translate(-1.092 -2.783)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49192",
    "data-name": "Path 49192",
    d: "M11.927,17.981l1.2,1.2,1.964-1.963",
    transform: "translate(-4.03 -5.818)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49193",
    "data-name": "Path 49193",
    d: "M12.423,12.137a7.053,7.053,0,0,1-3.4,1.439v3.649a2.247,2.247,0,0,0,.83,1.825c.544.4,2.164,1.471,2.233,1.516l.34.224.34-.224c.069-.046,1.69-1.115,2.233-1.516a2.247,2.247,0,0,0,.83-1.825V13.576A7.053,7.053,0,0,1,12.423,12.137Z",
    transform: "translate(-3.047 -4.101)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2388);
export default __webpack_public_path__ + "static/media/Group2388.4826ceb7c1c36941d449263c5bd551cd.svg";
export { ForwardRef as ReactComponent };